import React, { useEffect, useState } from "react";
import { history } from "../../_helpers";
import Button from "../../components/common/ui/Button";
import {
  DateInput,
  SelectInput,
  TextInput,
} from "../../components/common/ui/Inputs";
import Table from "../../components/common/table/Table";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import { useLocation } from "react-router-dom";
import {
  fDate,
  getCurrentDate,
  getPastDate,
  MinDate,
  Today,
} from "../../utils/formatTime";
import { useDispatch, useSelector } from "react-redux";
import {
  authActions,
  inmateAction,
  masterActions,
  publicUserActions,
} from "../../_store";
import Pending from "../../assets/svg/pending-user.svg";
import Approved from "../../assets/svg/approved.svg";
import generateXlsx from "../../components/common/export/generateXlsx";
import Rejected from "../../assets/svg/deactiveate-user.svg";
import CustomLoader from "../../components/common/ui/Loader";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import { findGraphemeClusters } from "../../components/common/ui/findGraphemeClusters";
import useManagementUserAccessPermission from "../../hooks/useManagementUserAccessPermission";


function InmatePhotos() {
  const location = useLocation();
  const { inmate: Inmate } = location.state || {};
  const { accessPermission, InmateAccessPermission, PuAccessPermission } = useManagementUserAccessPermission();
  const {
    user,
    commonFacilityCode: facilityCode,
    isDisabledInmate
  } = useSelector((x) => x.auth);
  const {
    inmateInfoTabData,
    phtotgridList: photoList,
    photoFullList,
    loading,
    inmate,
    inmateCurrentTab,
    intialPhotosSearch: photos
  } = useSelector((x) => x.inmate);
  const { publicUserLastName, publicUserFirstName } = useSelector(
    (x) => x.master
  );
  const [isloading, setisloading] = useState(false);
  const { ActiveStatus } = useSelector((x) => x.dropdownOptions);

  const [showSearchFields, setShowSearchFields] = useState(false);

  let initialPhoto = {
    FacilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
    InmateID: Inmate?.InmateID || inmate?.InmateID,
    InmateResidentID: Inmate?.InmateResidentId || inmate?.InmateResidentId,
    ManagementUserID: user?.ManagementUserID,
    InmateFirstName: Inmate?.FirstName || inmate?.FirstName,
    InmateLastName: Inmate?.LastName || inmate?.LastName,
    UserID: 0,
    UserFirstNameId: 0,
    UserLastNameId: 0,
    UserFirstName: "",
    UserLastName: "",
    PhotoAccess: 0,
    Subject: "",
    NoticesFromDate: getPastDate(6),
    NoticesToDate: getCurrentDate(),
    ActiveStatus: 4,
    ReceiverRead: 4,
    PageNo: 1,
    RowCountPerPage: 10,
    SortField: "",
  };

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({
        facilityID: 0,
        activeStatus: 1,
      })
    );
    const Inmate_Setting_Access = JSON.parse(process.env.REACT_APP_INMATE_SETTING);
    dispatch(authActions.updateisDisabledInmate(Inmate_Setting_Access.includes(user?.UserRoleID) ? false : true));
  }, [dispatch]);


  //Get the FirstName LastName
  useEffect(() => {
    if (!Inmate?.InmateID && !inmate?.InmateID) return;
    const facilityID = Inmate?.facilityID || inmate?.facilityID || facilityCode;
    const inmateID = Inmate?.InmateID || inmate?.InmateID;

    // Dispatch actions for public last name and first name
    dispatch(
      masterActions.GetPublicLastName({
        facilityID,
        firstName: "", // As per the existing logic, leaving firstName as empty string
        inmatesId: inmateID,
      })
    );

    if (photos?.UserLastNameId === 0 || photos?.UserLastNameId === undefined) {
      dispatch(
        masterActions.GetPublicFirstName({
          facilityID,
          lastName: "", // As per the existing logic, leaving lastName as empty string
          inmatesId: inmateID,
        })
      );
    }
    dispatch(
      inmateAction.LoadFacilityQuarantineBlock({
        facilityId: facilityID,
      })
    );
  }, [Inmate || inmate]);

  //Load the Grid

  useEffect(() => {
    if (!Inmate?.InmateID && !inmate?.InmateID) return;
    const updatedPhoto = {
      ...photos,
      FacilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
      InmateID: Inmate?.InmateID || inmate?.InmateID,
      InmateResidentID: Inmate?.InmateResidentId || inmate?.InmateResidentId,
      ManagementUserID: user?.ManagementUserID,
      InmateLastName: Inmate?.LastName || inmate?.LastName || (inmateInfoTabData && inmateInfoTabData[0]?.LastName) || "",
      InmateFirstName: Inmate?.FirstName || inmate?.FirstName || (inmateInfoTabData && inmateInfoTabData[0]?.FirstName) || ""
    };

    dispatch(inmateAction.setInitialPhotosSearch({
      ...photos,
      FacilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
      InmateID: Inmate?.InmateID || inmate?.InmateID,
      InmateResidentID: Inmate?.InmateResidentId || inmate?.InmateResidentId,
      ManagementUserID: user?.ManagementUserID,
      InmateLastName: Inmate?.LastName || inmate?.LastName || (inmateInfoTabData && inmateInfoTabData[0]?.LastName) || "",
      InmateFirstName: Inmate?.FirstName || inmate?.FirstName || (inmateInfoTabData && inmateInfoTabData[0]?.FirstName) || ""
    }));



    setisloading(true);
    dispatch(inmateAction.LoadPhotoSearchResult(updatedPhoto)).then((x) => { setisloading(false); })
  }, [Inmate || inmate]);


  //Redirect
  const navigateToPhotos = (row) => {
    if (accessPermission[0]?.SubMenuActiveStatus === 0) {
      return;
    }
    dispatch(inmateAction.setInmateCurrentTab("inmate-photos-tab"));
    history.navigate("/Admin/PhotoList/info", {
      state: {
        photoCommID: row?.PhotoCommID,
        source: "InmatePhotos",
        Inmate: Inmate,
      },
    });

    // dispatch(inmateAction.setInmateCurrentTab("inmate-info-tab"));
    // dispatch(inmateAction.setInmate(row));

  };

  const navigatePublicUser = (row) => {
    if (PuAccessPermission[0]?.SubMenuActiveStatus == 0) return;
    // if (isDisabledInmate) return;
    dispatch(publicUserActions?.setPublicUserTab("publicuser-info-tab"));
    history.navigate("PublicUserList/Details", {
      state: { row: row, source: "InmatePhotos", Inmate: Inmate },
    });
  };

  const navigateInmateInfo = (row) => {
    if (InmateAccessPermission[0]?.SubMenuActiveStatus == 0) return;
    // if (isDisabledInmate) return;
    history.navigate("InmateList/Details", {
      state: { inmate: Inmate, source: "InmatePhotos" },
    });
    dispatch(inmateAction?.setInmateCurrentTab("inmate-info-tab"));
  };

  const columns = [
    {
      name: "Subject",
      key: "PhotoSubject",
      selector: (row) => (
        <>
          {row.PhotoSubject}{" "}
          {/* {row.isNew && <span className="badge bg-danger ms-1">New</span>} */}
        </>
      ),
      cell: (row) => (
        <div className={`d-flex flex-wrap gap-2 align-items-start `}>
          <div
            onClick={() => navigateToPhotos(row)}
            className={` ${accessPermission[0]?.SubMenuActiveStatus !== 0
              ? "Common_Link_Style"
              : ""
              }`}
          >
            {/* {row.PhotoSubject} */}
            {findGraphemeClusters(row.PhotoSubject, false)?.length > 15
              ? findGraphemeClusters(row.PhotoSubject, true)
              : row.PhotoSubject}
          </div>
          {row?.UserPhotoReadStatus == false && (
            <div class="newbutton-container">
              New
              <div class="border-animation"></div>
            </div>
          )}
        </div>
      ),
      sortable: true,
    },
    {
      width: '140px',
      name: "From",
      key: "PhotoFrom",
      selector: (row) => (
        <div>
          <span className="badge bg-success me-2"></span> {row.PhotoFrom}
        </div>
      ),
      cell: (row) => (
        <div className="d-flex  gap-2 align-items-center">
          <div className="user-batch button-success"></div>
          <div
            className={` ${(PuAccessPermission[0]?.SubMenuActiveStatus !== 0 && user?.UserRoleID !== 13) ? "Common_Link_Style" : ""}`}
            onClick={() => navigatePublicUser(row)}
          >
            {row.PhotoFrom}
          </div>
        </div>
      ),
      sortable: true,
    },
    {
      width: '140px',
      name: "To",
      key: "PhotoTo",
      selector: (row) => (
        <div>
          <span className="badge bg-danger me-2"></span>
          {row.PhotoTo}
        </div>
      ),
      cell: (row) => (
        <div className="d-flex  gap-2 align-items-center">
          <div className="user-batch button-primary"></div>
          <div
            className={` ${(InmateAccessPermission[0]?.SubMenuActiveStatus !== 0 && user?.UserRoleID !== 13) ? "Common_Link_Style" : ""}`}
            onClick={() => navigateInmateInfo(row)}
          >
            {row.PhotoTo}
          </div>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Photo Cost ($)",
      key: "PhotoCost",
      selector: (row) => row.PhotoCost.toFixed(2), // Format as currency
      sortable: true,
    },
    {
      name: "Sent On",
      key: "PhotoSentDate",
      selector: (row) => row.PhotoSentDate,
      cell: (row) => (
        <div className="d-flex flex-wrap ">
          <div className="font-size-13 fw-500 ">{row?.PhotoSentDate}</div>
        </div>
      ),
      sortable: true,
    },
    {
      width: "80px",
      name: "Status",
      key: "PhotoActionStatus",
      sortable: true,
      selector: (row) => row.PhotoActionStatus,

      cell: (row) => {
        return (
          <div>
            <img
              title={
                row.PhotoActionStatus === "Pending"
                  ? "Pending"
                  : row.PhotoActionStatus === "Approved"
                    ? "Approved"
                    : row.PhotoActionStatus === "Rejected"
                      ? "Rejected"
                      : ""
              }
              src={
                row.PhotoActionStatus === "Pending"
                  ? Pending
                  : row.PhotoActionStatus === "Approved"
                    ? Approved
                    : row.PhotoActionStatus === "Rejected"
                      ? Rejected
                      : ""
              }
              style={{ width: "20px", height: "20px" }} // Adjust icon size as needed
            />
          </div>
        );
      },
      center: true,
    },
  ];

  //Table Pagination

  const handlePageChange = (pageNo) => {
    if (isSorting) {
      isSorting = false;
      return;
    }
    const updatedParam = {
      ...photos,
      PageNo: pageNo,
      FacilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
      InmateID: Inmate?.InmateID || inmate?.InmateID,
      InmateResidentID: Inmate?.InmateResidentId || inmate?.InmateResidentId,
      ManagementUserID: user?.ManagementUserID,
      InmateLastName: Inmate?.LastName || inmate?.LastName || (inmateInfoTabData && inmateInfoTabData[0]?.LastName) || "",
      InmateFirstName: Inmate?.FirstName || inmate?.FirstName || (inmateInfoTabData && inmateInfoTabData[0]?.FirstName) || ""
    }

    dispatch(inmateAction.setInitialPhotosSearch(updatedParam));
    dispatch(inmateAction.LoadPhotoSearchResult({ ...photos, PageNo: pageNo }));
  };

  const handleRowPerPage = (rowCount) => {
    const updatedParam = {
      ...photos,
      PageNo: 1,
      RowCountPerPage: rowCount,
      FacilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
      InmateID: Inmate?.InmateID || inmate?.InmateID,
      InmateResidentID: Inmate?.InmateResidentId || inmate?.InmateResidentId,
      ManagementUserID: user?.ManagementUserID,
      InmateLastName: Inmate?.LastName || inmate?.LastName || (inmateInfoTabData && inmateInfoTabData[0]?.LastName) || "",
      InmateFirstName: Inmate?.FirstName || inmate?.FirstName || (inmateInfoTabData && inmateInfoTabData[0]?.FirstName) || ""
    }
    dispatch(inmateAction.setInitialPhotosSearch(updatedParam));
    dispatch(inmateAction.LoadPhotoSearchResult({ ...updatedParam }));
  };

  let isSorting = false;
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    isSorting = true;
    const search = { ...photos };
    const newSortOrder = search.SortField.includes(column.key)
      ? search.SortField.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";

    search.SortField = `${column.key} ${newSortOrder}`;
    dispatch(inmateAction.setInitialPhotosSearch(search));
    dispatch(
      inmateAction.LoadPhotoSearchResult({
        ...photos,
        SortField: `${column.key} ${newSortOrder}`,
      })
    );
  };

  //Export
  useEffect(() => {
    if (photoFullList && photoFullList?.DataList?.length > 0) {
      let title = "Photo_List";
      let generateExcelColumns = [
        "Subject",
        "From",
        "To",
        "Photo Cost($)",
        "Sent On",
        "Status",
      ];

      // Map the account manager list to match the Excel format
      let PUPhoto_List =
        photoFullList?.DataList?.map((obj) => ({
          Subject: obj.PhotoSubject,
          From: obj.PhotoFrom,
          To: obj.PhotoTo,
          PhotoCost: obj.PhotoCost.toFixed(2),
          Sent: obj.PhotoSentDate,
          Status: obj.PhotoActionStatus,
        })) || [];

      try {
        // Generate the Excel file with the transformed data
        generateXlsx(PUPhoto_List, generateExcelColumns, title);

        // Clear excel data after the download
        dispatch(inmateAction.clearPhotoFullList());
      } catch (error) {
        // Handle any errors that occur during Excel generation
        showToastNotification("error", "error");
      }
    }
  }, [photoFullList]);

  const handleExcel = () => {
    let updatedParam = {
      ...photos,
      PageNo: 1,
      exportExcel: true,
      RowCountPerPage: photoList?.TotalRecordCount,
    };
    dispatch(inmateAction.LoadPhotoSearchResult(updatedParam));
  };

  //
  let { ...updatedSearch } = photos;
  const handleSelectChange = (selectedOption, name) => {
    const LoadPhotoGridList = () => {
      updatedSearch.PageNo = 1;
      updatedSearch.RowCountPerPage = 10;
      updatedSearch.SortField = "";
      dispatch(inmateAction.LoadPhotoSearchResult(updatedSearch));
    };

    const handleFirstName = () => {
      updatedSearch[name] =
        selectedOption?.value > 0 ? selectedOption?.label : "";
      updatedSearch.UserFirstNameId = selectedOption?.value || 0;

      // dispatch(
      //   masterActions.GetPublicLastName({
      //     facilityID: updatedSearch.FacilityID,
      //     firstName: updatedSearch.UserFirstName,
      //     inmatesId: updatedSearch.InmateID,
      //   })
      // );

      LoadPhotoGridList();
    };

    const handleLastName = () => {
      updatedSearch[name] =
        selectedOption?.value > 0 ? selectedOption?.label : "";
      updatedSearch.UserLastNameId = selectedOption?.value || 0;

      updatedSearch.UserFirstName = "";
      updatedSearch.UserFirstNameId = 0;
      dispatch(
        masterActions.GetPublicFirstName({
          facilityID: updatedSearch.FacilityID,
          lastName: updatedSearch.UserLastName,
          inmatesId: updatedSearch.InmateID,
        })
      );

      LoadPhotoGridList();
    };

    switch (name) {
      case "UserLastName":
        handleLastName();
        break;

      case "UserFirstName":
        handleFirstName();
        break;

      default:
        updatedSearch[name] = selectedOption?.value || 4;
        LoadPhotoGridList();
        break;
    }

    dispatch(inmateAction.setInitialPhotosSearch(updatedSearch));
  };

  const handleDateChange = (value, name) => {
    const date = fDate(value);
    updatedSearch[name] = date;

    dispatch(inmateAction.setInitialPhotosSearch(updatedSearch));
  };

  const handleDateEnterKey = (event, name) => {
    if (event.key === "Enter" && updatedSearch[name] === "") {
      const currentDate = new Date();

      // Set today's date using the same logic as your handleDateChange
      handleDateChange(currentDate, name);
    }

    const regex = /^[0-9/]$/; // Allow numbers and "/"

    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }
  };

  const handleDateBlur = (e, fieldName) => {
    let { value } = e.target;
    let isFromValid = true;
    let isToValid = true;

    if (fieldName === "NoticesFromDate") {
      if (
        updatedSearch.NoticesToDate &&
        new Date(value) > new Date(updatedSearch.NoticesToDate)
      ) {
        // Invalid: FromDate cannot be after ToDate
        isFromValid = false;
      }
    } else if (fieldName === "NoticesToDate") {
      if (
        updatedSearch.NoticesFromDate &&
        new Date(value) < new Date(updatedSearch.NoticesFromDate)
      ) {
        // Invalid: ToDate cannot be before FromDate
        isToValid = false;
      }
    }

    // Define date format used
    const minDate = MinDate();
    const today = Today();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate && valueDate <= today;

    let updatedParam = {
      ...updatedSearch,
      NoticesFromDate:
        fieldName === "NoticesFromDate"
          ? isFromValid && isValidDate
            ? value
            : ""
          : updatedSearch.NoticesFromDate, // preserve existing value
      NoticesToDate:
        fieldName === "NoticesToDate"
          ? isToValid && isValidDate
            ? value
            : ""
          : updatedSearch.NoticesToDate, // preserve existing value
    };
    dispatch(inmateAction.setInitialPhotosSearch(updatedParam));
  };

  const handleChange = (e) => {
    let { name, value } = e?.target;
    updatedSearch[name] = value;
    dispatch(inmateAction.setInitialPhotosSearch(updatedSearch));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const search = {
      ...updatedSearch, PageNo: 1, RowCountPerPage: 10,
      InmateLastName: Inmate?.LastName || inmate?.LastName || (inmateInfoTabData && inmateInfoTabData[0]?.LastName),
      InmateFirstName: Inmate?.FirstName || inmate?.FirstName || (inmateInfoTabData && inmateInfoTabData[0]?.FirstName)
    }
    dispatch(inmateAction.setInitialPhotosSearch({
      ...photos,
      PageNo: 1, RowCountPerPage: 10,
      InmateLastName: Inmate?.LastName || inmate?.LastName || (inmateInfoTabData && inmateInfoTabData[0]?.LastName),
      InmateFirstName: Inmate?.FirstName || inmate?.FirstName || (inmateInfoTabData && inmateInfoTabData[0]?.FirstName)
    }));
    setisloading(true);
    dispatch(inmateAction.LoadPhotoSearchResult(search)).then((x) => { setisloading(false); });
  };

  const handleReset = () => {
    dispatch(
      masterActions.GetPublicFirstName({
        facilityID: updatedSearch.FacilityID,
        lastName: "",
        inmatesId: updatedSearch.InmateID,
      })
    );
    const resetPhoto = {
      ...initialPhoto,
      FacilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
      InmateID: Inmate?.InmateID || inmate?.InmateID,
      InmateResidentID: Inmate?.InmateResidentId || inmate?.InmateResidentId,
      ManagementUserID: user?.ManagementUserID,
      InmateLastName: Inmate?.LastName || inmate?.LastName || (inmateInfoTabData && inmateInfoTabData[0]?.LastName) || "",
      InmateFirstName: Inmate?.FirstName || inmate?.FirstName || (inmateInfoTabData && inmateInfoTabData[0]?.FirstName) || ""
    }
    dispatch(inmateAction.setInitialPhotosSearch(resetPhoto));
    setisloading(true);
    dispatch(inmateAction.LoadPhotoSearchResult(resetPhoto)).then((x) => { setisloading(false); });
  };

  if (loading || isloading) {
    return <CustomLoader />;
  }

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };

  const renderSearch = () => {
    return (
      <form onSubmit={handleSubmit}>
        {/* First Row: Username, Last Name, First Name */}
        <div className="row">
          <div className="p-2 m-1 d-flex flex-wrap align-items-center">
            {/* Frequency */}
            <div className="col-sm-12 col-md-4 d-flex flex-wrap align-items-center me-1">
              <label className="fs-5" style={{ minWidth: "150px" }}>
                Inmate Last Name :
              </label>
              <strong className="fs-5 text-end mx-2">
                {Inmate?.LastName ||
                  inmate?.LastName ||
                  (inmateInfoTabData && inmateInfoTabData[0]?.LastName)}
              </strong>
            </div>

            {/* Limit */}
            <div className="col-sm-12 col-md-4 d-flex flex-wrap align-items-center">
              <label className="fs-5" style={{ minWidth: "150px" }}>
                Inmate First Name :
              </label>
              <strong className="fs-5 text-end mx-2">
                {Inmate?.FirstName ||
                  inmate?.FirstName ||
                  (inmateInfoTabData && inmateInfoTabData[0]?.FirstName)}
              </strong>
            </div>
          </div>
        </div>
        <div className="row">
          {/* Second Row: Email, State, City */}

          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              {/* State */}
              <SelectInput
                options={publicUserLastName}
                value={photos?.UserLastNameId}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "UserLastName")
                }
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={photos?.UserLastNameId !== 0}
                placeholder="Select LastName"
                label="Public User Last Name"
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              {/* State */}
              <SelectInput
                options={publicUserFirstName}
                value={photos?.UserFirstNameId}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "UserFirstName")
                }
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={photos?.UserFirstNameId !== 0}
                placeholder="Select State"
                label="Public User First Name"
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              <TextInput
                name="Subject"
                id="Subject"
                label="Subject"
                value={photos?.Subject}
                handleChange={handleChange}
                placeholder="Enter Subject"
                maxLength={50}
                required={false}
              />
            </div>
          </div>

          {/* Third Row: Phone Number, From Date, To Date */}

          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              <DateInput
                value={photos.NoticesFromDate}
                handleChange={(e) => handleDateChange(e, "NoticesFromDate")}
                name="NoticesFromDate"
                label={"From Date"}
                maxDate={
                  photos?.NoticesToDate ? photos?.NoticesToDate : new Date()
                }
                required={false}
                disabled={false}
                yearDropDown={true}
                isClearable={photos.NoticesFromDate ? true : false}
                monthDropDown={false}
                className={false ? "disabled-date-input" : ""} // Add class conditionally
                minDate={new Date(2017, 0, 1)}
                handleBlur={(e) => handleDateBlur(e, "NoticesFromDate")}
                handleKeyDown={(e) => handleDateEnterKey(e, "NoticesFromDate")}
              ></DateInput>
            </div>
          </div>

          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              <DateInput
                value={photos?.NoticesToDate}
                handleChange={(e) => handleDateChange(e, "NoticesToDate")}
                name="NoticesToDate"
                minDate={
                  photos?.NoticesFromDate
                    ? photos?.NoticesFromDate
                    : new Date(2017, 0, 1)
                }
                label={"To Date"}
                maxDate={new Date()}
                required={false}
                isClearable={photos?.NoticesToDate ? true : false}
                disabled={false}
                yearDropDown={true}
                monthDropDown={false}
                handleBlur={(e) => handleDateBlur(e, "NoticesToDate")}
                handleKeyDown={(e) => handleDateEnterKey(e, "NoticesToDate")}
              ></DateInput>
            </div>
          </div>

          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              {/* Status */}
              <SelectInput
                options={ActiveStatus}
                value={photos?.ActiveStatus} // This is the selected value (e.g., 0, 1)
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "ActiveStatus")
                }
                isClearable={photos?.ActiveStatus !== 4}
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                placeholder="Select Status"
                label={"Status"}
              />
            </div>
          </div>

          {/* Fourth Row: Connection, Status */}
        </div>

        {/* Buttons */}
        <div className="mt-3 d-flex flex-wrap justify-content-center gap-3">
          <Button
            // variant="danger"
            className="me-2"
            label={"SEARCH"}
            type={"submit"}
            status={"primary"}
            disabled={false}
            icon={"search"}
          ></Button>
          <Button
            variant="danger"
            className="me-2"
            onClick={handleReset} // This will now work correctly
            label={"RESET"}
            type={"button"}
            status={"secondary"}
            disabled={false}
            icon={"fa-solid fa-rotate-right"}
          />
        </div>
      </form>
    );
  };

  return (
    <div>
      <div className="p-2 ">
        <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap ">
          <h4 className=" inner-subheader-bg text-color">
            <i class="fa fa-camera me-2"></i>Photos
          </h4>
          <Button
            label="Back"
            type="button"
            status="primary"
            icon={"fa-solid fa-angle-left"}
            onClick={() => {
              history.navigate("/Admin/InmateList");
              dispatch(inmateAction.setInmateCurrentTab("inmate-info-tab"));
            }}
          />
        </div>
      </div>
      <div className="card shadow-sm b-r-all p-3 border border-dark-grey mt-1 w-100">
        <div className=" d-block d-md-none">
          <div
            className=" d-flex align-items-center justify-content-between"
            style={{ background: "transparent", cursor: "pointer" }}
            onClick={toggleInformation}
          >
            <h2 className="form_title_uppercase text-color">SEARCH</h2>
            <i
              id="itagInformation"
              className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""}`}
              style={{ fontSize: "20px" }}
            ></i>
          </div>
        </div>
        {/* Mobile only (Below md breakpoint) */}
        <div className="d-block d-md-none">
          {showSearchFields && renderSearch()}
        </div>

        {/* Web only (Desktop and above) */}
        <div className="mb-3 d-none d-md-block">
          <h2 className="form_title_uppercase text-color">SEARCH</h2>
        </div>
        {/* Web only (Desktop and above) */}
        <div className="d-none d-md-block">{renderSearch()}</div>
      </div>

      <div className="mt-3">
        <div className="d-flex flex-wrap  justify-content-end mb-3">
          {photoList?.DataList?.length > 0 && (
            <ExcelExport variant="soft-gray" handleExcelExport={handleExcel} />
          )}
        </div>
        {/* Table Section */}
        <Table
          columns={columns}
          data={photoList?.DataList}
          pagination={true}
          onChangePage={(e) => handlePageChange(e)} // Call API when page changes
          onChangeRowsPerPage={(e) => handleRowPerPage(e)}
          totalRowCount={photoList?.TotalRecordCount}
          currentPage={photos?.PageNo}
          paginationPerPage={photos?.RowCountPerPage}
          onSort={handleSort}
          serverSideSort
          sortColumn={photos?.SortField?.split(" ")[0]}
          sortDirection={photos?.SortField?.split(" ")[1]}
        />
      </div>
    </div>
  );
}

export default React.memo(InmatePhotos);
